import type { LinkProps } from '@wix/editor-elements-definitions';

export function usePlatformLink(linkProps: LinkProps | undefined) {
  if (!linkProps) {
    return {};
  }

  // @ts-expect-error
  const { href, target, rel, anchorDataId, linkPopupId } =
    linkProps.resolvedLink ? linkProps.resolvedLink : linkProps;

  return {
    href,
    target,
    rel,
    'data-anchor': anchorDataId,
    'data-popupid': linkPopupId,
  };
}
